import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Badge, Breadcrumb,  Card, Col, Divider, Grid, Input, Modal, notification, Popover, Row, Space, Spin, Statistic, Tabs } from 'antd';

import { Box, Typography, Button, Paper, IconButton } from "@mui/material";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useDailyJournalMutation, useSaveNoteMutation } from "../slices/zerodhaApiSlice";
import { setDailyjournal } from "../slices/dailyjournalSlice";
import MyEditor from "./Usercomp/MyEditor";
import DailyTradeDescription from "./Usercomp/DailyTradeDescription";
import AreaGredientChartY from "./Usercomp/AreaGredientChartY";

const TradeCalendar = ({ journalData = [], onOpenNote }) => {

console.log(journalData,"journal data");


  
  // console.log("all trades", trades);
    const [api, contextHolder] = notification.useNotification();
  
  // const { date } = useSelector((state) => state.date);
  // const { dashboard } = useSelector((state) => state.dashboard);
  // // const { darkmode } = useSelector((state) => state.darkmode);
  // const { dailyjournal } = useSelector((state) => state.dailyjournal);
  // const [modeldata, setModeldata] = useState({});
  // const [content, setContent] = useState("");
  // const [notetitle, setNotetitle] = useState("");
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalRecords, setTotalRecords] = useState(0);
  // const [data, setData] = useState([]);
  
  // const [dailyJournal, { isLoading: isJournalLoading }] = useDailyJournalMutation();
  // const [saveNote, { isLoading: isSaveNoteLoading }] = useSaveNoteMutation();

  // const dispatch = useDispatch();

  // //  console.log(order, "order")
  //     const pageSize = 5; // Cards per page
      
      
  //     // Fetching journal data with pagination
  //     const fetchJournal = useCallback(async (page = 1) => {
  //       try {
  //         const res = await dailyJournal({
  //           startDate: date.startDate,
  //           endDate: date.endDate,
  //           page,
  //           pageSize,
  //         }).unwrap();
          
  //         if (res && res.data) {
  //           setData(res.data.results || []); // Update state with the fetched data
  //           setTotalRecords(res.data.totalCount || 0); // Update total records for pagination
  //           dispatch(setDailyjournal(res.data)); // If needed for other states
  //         }
          
  //         // console.log("daily..journal",res);
          
          
  //       } catch (err) {
  //         api.error({ message: err?.data?.message || err.error || err?.data?.error || err?.data?.error });
  //       }
  //     }, [dailyJournal, date, dispatch, api]);
      
  //     useEffect(() => {
  //       fetchJournal(currentPage);
  //     }, [currentPage, fetchJournal]); // Depend only on currentPage and fetchJournal
      
          
  //         const [showid, setShowid] = useState(0)
  //         const show = (show, sid) => [
  //           showid === sid ? setShowid(0) : setShowid(sid)
  //         ]
  //         const { useBreakpoint } = Grid;
  //         const screens = useBreakpoint();
  //         const newDate = new Date();
  //         const { Text, Title } = Typography;
          
  //         // Sync modal content whenever `modeldata` changes
  //         useEffect(() => {
  //           if (modeldata) {
  //             setNotetitle(modeldata?.note?.title || "");
  //             setContent(modeldata?.note?.content || "");
  //           }
  //         }, [modeldata]);
          
  //         // Show modal with data
  //         const showModal = (data) => {
  //           setModeldata(data || {}); // If `data` is null, reset
  //           setIsModalOpen(true);
  //         };
          
  //         const handleOk = async () => {
  //           try {
  //             const _id = modeldata?._id;
  //             await saveNote({ notetitle, content, _id }).unwrap();
  //             api.success({ message: "Note Saved!" });
  //             resetModal();
  //             // fetchJournal(currentPage);
  //           } catch (err) {
  //             api.error({ message: err?.data?.message || err.error || err?.data?.error || err?.data?.error });
  //           }
  //         };
          
  //         const handleCancel = () => {
  //           resetModal();
  //         };
          
  //         // Reset modal states for a clean start
  //         const resetModal = () => {
  //           setIsModalOpen(false);
  //           setModeldata({});
  //           setNotetitle("");
  //           setContent(""); // Reset content
  //         };
          
  //         // const [activeBroker, setActiveBroker] = useState(brokerData[0].code);
  //               //  const  journalData=dailyjournal?.results || []

  // // const onOpenNote=(data) => {
  // //       setModeldata(data);
  // //       setIsModalOpen(true); // opens MyEditor modal 
  // //     }
    
  const [currentDate, setCurrentDate] = useState(new Date());
    const { darkmode } = useSelector((state) => state.darkmode);
const bgColor = darkmode ? "#141414" : "#ffffff";
const cardBg = darkmode ? "#1f1f1f" : "#ffffff";
const borderColor = darkmode ? "#303030" : "#e5e7eb";

const profitBg = darkmode ? "#092b00" : "#ecfdf5";
const lossBg = darkmode ? "#fff1f0" : "#fff1f0";

const textColor = darkmode ? "#ffffff" : "#000000";
  const { tradelogs } = useSelector((state) => state.tradelogs);
console.log(tradelogs);
console.log(journalData);
console.log(onOpenNote);


  /* ================= TRADE LOG MAP ================= */
  const tradeLogMap = useMemo(() => {
    const map = {};
    tradelogs?.trades?.forEach((trade) => {
      if (!trade?.closing_date) return;
      const key = moment(trade.closing_date).format("YYYY-MM-DD");

      if (!map[key]) map[key] = { pnl: 0, trades: [] };

      map[key].pnl += Number(trade.profit || 0);
      map[key].trades.push(trade);
    });
    return map;
  }, [tradelogs]);

  /* ================= JOURNAL MAP ================= */
  const journalMap = useMemo(() => {
    const map = {};
    journalData?.forEach((j) => {
      const key = moment(j.date || j._id).format("YYYY-MM-DD");
      map[key] = j;
    });
    return map;
  }, [journalData]);
console.log("Journal Map:", journalMap);

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  /* ================= MONTHLY PNL ================= */
  const monthlyPnl = useMemo(() => {
    let total = 0;
    tradelogs?.trades?.forEach((t) => {
      if (
        t?.closing_date &&
        moment(t.closing_date).month() === month &&
        moment(t.closing_date).year() === year
      ) {
        total += Number(t.profit || 0);
      }
    });
    return total;
  }, [tradelogs, month, year]);

  /* ================= WEEKLY PNL ================= */
  const getWeeklyPnl = (date) => {
    const start = moment(date).startOf("week");
    const end = moment(date).endOf("week");
    let total = 0;

    tradelogs?.trades?.forEach((t) => {
      if (!t?.closing_date) return;
      const d = moment(t.closing_date);
      if (d.isBetween(start, end, "day", "[]")) {
        total += Number(t.profit || 0);
      }
    });
    return total;
  };

  const getTradeLogByDate = (day) => {
    const dateStr = moment(new Date(year, month, day)).format("YYYY-MM-DD");
    return tradeLogMap[dateStr];
  };

  const getJournalByDate = (day) => {
    const dateStr = moment(new Date(year, month, day)).format("YYYY-MM-DD");
    return journalMap[dateStr];
  };

  return (
    
<Box p={2} sx={{ backgroundColor: bgColor, borderRadius: 2 }}>
      <Box
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(8, 120px)", // fixed width columns
      md: "repeat(8, 1fr)",
    },
    overflowX: { xs: "auto", md: "visible" },
    mb: 1,
  }}
>

      {/* Header */}
      {/* <Box display="flex" justifyContent="space-between" mb={2}> */}
        <Button onClick={() => setCurrentDate(new Date(year, month - 1, 1))}>
          ◀
        </Button>
        <Typography variant="h6">
          {currentDate.toLocaleString("default", { month: "long" })} {year}
        </Typography>
        <Button onClick={() => setCurrentDate(new Date(year, month + 1, 1))}>
          ▶
        </Button>
      </Box>

      {/* Monthly PnL */}
      <Paper
        sx={{
          mb: 2,
          p: 1,
          textAlign: "center",
          backgroundColor: monthlyPnl >= 0 ? profitBg : lossBg,
          color: textColor,
          border: `1px solid ${borderColor}`        }}
          >
        <Typography fontWeight="bold" color={monthlyPnl >= 0 ? "green" : "red"}>
          Monthly PnL ₹ {monthlyPnl.toFixed(2)}
        </Typography>
      </Paper>

      {/* Header Row */}
      <Box display="grid" gridTemplateColumns="repeat(8, 1fr)" mb={1}>
        {["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Weekly PnL"].map(d => (
          <Typography key={d} align="center" fontWeight="bold"  sx={{ color: textColor }}>

          
            {d}
          </Typography>
        ))}
      </Box>

      {/* Calendar Body */}
      
      <Box
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(8, 120px)",
      md: "repeat(8, 1fr)",
    },
    gap: 1.5,
    overflowX: { xs: "auto", md: "visible" },
  }}
>

      {/* <Box display="grid" gridTemplateColumns="repeat(8, 1fr)" gap={1.5}> */}
        {(() => {
          const weeks = [];
          let dayCounter = 1 - firstDay;
          
          while (dayCounter <= daysInMonth) {
            const weekDays = [];
            
            for (let i = 0; i < 7; i++) {
              if (dayCounter < 1 || dayCounter > daysInMonth) {
                weekDays.push(<Box key={`empty-${dayCounter}`} />);
              } else {
                const day = dayCounter;
                const tradeData = getTradeLogByDate(day);
                const journal = getJournalByDate(day);
                
                weekDays.push(
                  // <Paper
                  //   key={day}
                  //   elevation={2}
                  //   sx={{
                    //     height: 150,
                    //     p: 1.5,
                    //     position: "relative",
                    //     overflowY: "auto",
                    //   }}
                    // >
                    <Paper
                    key={day}
                    elevation={2}
                    sx={{
                      height: { xs: 120, md: 150 },
                      p: 1.5,
                      position: "relative",
                      overflowY: "auto",
                      backgroundColor: tradeData
                      ? tradeData.pnl < 0
                      ? lossBg
                      : profitBg
                      : cardBg,
                      color: textColor,
                      border: `1px solid ${borderColor}`,
                      transition: "0.2s",
                      "&:hover": {
                        transform: "scale(1.02)",
                      },}}
>

{tradeData && (
  <Box sx={{ position: "absolute", top: 4, right: 4 }}>
    {journal ? (
      <IconButton
      size="small"
      onClick={() => onOpenNote(journal)}
      >
        <VisibilityIcon fontSize="small" />
      </IconButton>
    ) : (
      <IconButton
      size="small"
      onClick={() =>
        onOpenNote({
          trade_date: moment(
            new Date(year, month, day)
          ).format("YYYY-MM-DD"),
          note: { title: "", content: "" },
        })
      }
      >
        <NoteAddIcon fontSize="small" />
      </IconButton>
    )}
  </Box>
)}


                    <Typography fontWeight="bold">{day}</Typography>

                    {tradeData && (
                      <Box mt={1}
                      >
                        <Typography
                          fontSize={12}
                          fontWeight="bold"
                          color={tradeData.pnl >= 0 ? "green" : "red"}
                          
                          >
                          Total ₹ {tradeData.pnl.toFixed(2)}
                        </Typography>

                        {tradeData.trades.map((trade, index) => (
                          <Box key={index} mt={0.5}>
                            {/* <Typography fontSize={10}>
                              {trade.broker || trade.brokerName || "Broker"} |{" "}
                              {trade.trading_symbol ||
                              trade.tradingSymbol ||
                              trade.symbol}
                              </Typography> */}
<Typography fontSize={10}  style={{ color: textColor }}>
  {trade.trading_symbol ||
    trade.tradingSymbol ||
    trade.symbol}
  {" ("}
  {trade.broker?.code ||
    trade.broker_code ||
    trade.broker ||
    "BRK"}
  {")"}
</Typography>

                            <Typography
                              fontSize={10}
                              color={
                                Number(trade.profit) >= 0 ? "green" : "red"
                              }
                              >
                              ₹ {Number(trade.profit || 0).toFixed(2)}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Paper>
                );
              }
              dayCounter++;
            }
            
            const weekEndDate = new Date(
              year,
              month,
              Math.min(dayCounter - 1, daysInMonth)
            );
            const weeklyPnl = getWeeklyPnl(weekEndDate);
            
            weekDays.push(
              <Paper
              key={`weekly-${dayCounter}`}
              elevation={2}
              sx={{
                height: 150,
                p: 1.5,
                textAlign: "center",
                backgroundColor: weeklyPnl >= 0 ? "#ecfdf5" : "#fff1f0",
              }}
              >
                <Typography fontSize={12} fontWeight="bold">
                  Weekly
                </Typography>
                <Typography
                  fontWeight="bold"
                  color={weeklyPnl >= 0 ? "green" : "red"}
                  >
                  ₹ {weeklyPnl.toFixed(2)}
                </Typography>
              </Paper>
            );
            
            weeks.push(weekDays);
          }
          
          return weeks.flat();
        })()}
      </Box>

{/* 

<Modal
                  title={
                    <>
                          <Text>{moment(modeldata?._id).format('ddd, D MMM, YYYY')} <Badge status="default" /></Text>
                       <Text
    type={
      (modeldata?.totalProfit - modeldata?.totalLoss) >= 0
      ? "success"
      : "danger"
    }
    >
    Realised P&L ₹{" "}
    {isJournalLoading
      ? 0
      : (modeldata?.totalProfit - modeldata?.totalLoss).toFixed(2)}
  </Text>
  
                      </>
                  }
                  width={1000}
                  open={isModalOpen}
                  onOk={handleOk}
                  confirmLoading={isSaveNoteLoading}
                  onCancel={handleCancel}
                  
                  >
                  <Row gutter={[16, 24]} style={{ marginBottom: '10px' }}>
                      <Col md={8} xs={24}><AreaGredientChartY datal={isJournalLoading ? [] : modeldata.runningPnlArray} /></Col>
                      <Col md={16} xs={24}><DailyTradeDescription data={modeldata} /></Col>
                  </Row>
                  <Row>
                      <Input
                          type="text"
                          placeholder="Title"
                          value={notetitle}
                          onChange={(e) => setNotetitle(e.target.value)}
                          style={{ marginBottom: "10px" }}
                          /> */}
                      {/* {isModalOpen && <MyEditor setContent={setContent} initialContent={content} />} Render only when modal is open */}
                  {/* </Row> */}
              {/* </Modal> */}
  
</Box>
                        );
       
};

export default TradeCalendar;



  // <TradeCalendar
  //       journalData={dailyjournal?.results || []}
  
  //     onOpenNote={(data) => {
    //       setModeldata(data);
    //       setIsModalOpen(true); // opens MyEditor modal 
    //     }}
    //   />
    